import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureAccessoryDetailsModalClasses =
  | 'modalRoot'
  | 'modalPaper'
  | 'modalContentContainer'
  | 'imageContainer'
  | 'description'
  | 'title'
  | 'header'
  | 'modalActionsContainer'
  | 'button';

const featureAccessoryDetailsModalStyles = makeStyles<ISpcTheme, FeatureAccessoryDetailsModalClasses>(
  ({ typography, breakpoints }) => ({
    modalRoot: {
      padding: 0,
    },
    modalPaper: {
      width: '100%',
      [breakpoints.up('sm')]: {
        borderRadius: 0,
        boxShadow: 'none',
        maxWidth: '80vw',
      },
    },
    modalContentContainer: {
      padding: '40px 20px 0',
    },
    imageContainer: {
      [breakpoints.up('sm')]: {
        padding: '40px 0 0 40px',
      },
    },
    description: {
      fontFamily: typography.fontFamily,
      fontSize: typography.fontSM,
      fontWeight: typography.fontWeightLight,
      marginTop: '20px',
    },
    header: {
      fontFamily: typography.fontFamily,
      fontWeight: typography.fontWeightLight,
      fontSize: typography.fontXL,
    },
    title: {
      marginBottom: '10px',
      textTransform: 'uppercase',
    },
    modalActionsContainer: {
      padding: '40px 20px',
      [breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
    button: {
      borderRadius: 0,
      fontWeight: typography.fontWeightBold,
    },
  }),
  { name: 'Customise_Feature_Accessory_DetailsModal' },
);

export default featureAccessoryDetailsModalStyles;
